import React from 'react';

const VideoSection = props => {
  return (
    <div className="row">
      <div
        className="col-md-8 col-md-offset-2 text-center"
        style={{ marginTop: 80, marginBottom: 80 }}
      >
        <div className="embed-responsive embed-responsive-16by9">
          <iframe
            title="Christkind-Helfer Video"
            className="embed-responsive-item"
            src="//www.youtube.com/embed/hBRUbj4Ybxc?autoplay=0&showinfo=0&controls=0"
          />
        </div>
      </div>
    </div>
  );
};
export default VideoSection;



// WEBPACK FOOTER //
// ./src/Containers/HomeElements/VideoSection.js